import { buttonClasses } from '@mui/material/Button';
import type { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme: Theme) => ({
  button: {
    [`&.${buttonClasses.text}`]: {
      textTransform: 'none',
      color: theme.palette.primary.main,
    },
  },
}));

export default useStyles;
